import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "className", "collapsed", "collapsedContent", "collapsingIconClasses", "collapsedWidth", "uncollapsedWidth", "initialyClosed", "isCollapsible", "onOpenChange"];
import { faChevronsRight, faChevronsLeft } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import React, { forwardRef } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "container": "pbui-ah16q",
  "icon__container": "pbui-uVxWb",
  "icon__container--collapsed": "pbui-G2piL",
  "icon__container--not-collapsed": "pbui-NO1HJ",
  "icon": "pbui-FfgW3"
};
var Sidebar = /*#__PURE__*/forwardRef(function Sidebar(props, ref) {
  var _ref;
  var children = props.children,
    className = props.className,
    collapsed = props.collapsed,
    collapsedContent = props.collapsedContent,
    collapsingIconClasses = props.collapsingIconClasses,
    _props$collapsedWidth = props.collapsedWidth,
    collapsedWidth = _props$collapsedWidth === void 0 ? 40 : _props$collapsedWidth,
    _props$uncollapsedWid = props.uncollapsedWidth,
    uncollapsedWidth = _props$uncollapsedWid === void 0 ? 256 : _props$uncollapsedWid,
    _props$initialyClosed = props.initialyClosed,
    initialyClosed = _props$initialyClosed === void 0 ? false : _props$initialyClosed,
    _props$isCollapsible = props.isCollapsible,
    isCollapsible = _props$isCollapsible === void 0 ? false : _props$isCollapsible,
    onOpenChange = props.onOpenChange,
    rest = _objectWithoutProperties(props, _excluded);
  var _React$useState = React.useState(),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    localCollapsed = _React$useState2[0],
    setLocalCollapsed = _React$useState2[1];
  var close = (_ref = collapsed != null ? collapsed : localCollapsed) != null ? _ref : initialyClosed;
  var setClose = collapsed !== undefined && onOpenChange ? onOpenChange : setLocalCollapsed;
  var containerClasses = clsx(styles.container, className);
  var iconContainerClasses = clsx(styles['icon__container'], close ? styles['icon__container--collapsed'] : styles['icon__container--not-collapsed']);
  var iconClasses = clsx(styles.icon, collapsingIconClasses);
  return /*#__PURE__*/_jsx("div", _extends({
    style: {
      width: close ? collapsedWidth : uncollapsedWidth
    },
    className: containerClasses
  }, rest, {
    ref: ref,
    children: isCollapsible ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("div", {
        className: iconContainerClasses,
        children: /*#__PURE__*/_jsx(FontAwesomeIcon, {
          icon: close ? faChevronsRight : faChevronsLeft,
          size: "sm",
          className: iconClasses,
          onClick: function onClick() {
            return setClose(!close);
          }
        })
      }), close ? collapsedContent : children]
    }) : children
  }));
});
export default Sidebar;